(function () {
    'use strict';

    angular.module("imApp").factory("collectionService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1220,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1221,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
